export const CUMPLE_SESSION_KEY = "cumple_checkout_draft_v1";
const SESSION_TTL_MS = 30 * 60 * 1000;

export type CumpleFormData = {
  selectedAmount: string;
  customAmount: string;
  message: string;
  name: string;
  email: string;
};

export type CumpleSession = {
  formData: CumpleFormData;
  donationId: string | null;
  savedAt: number;
};

export function loadCumpleSession(): CumpleSession | null {
  try {
    const raw = sessionStorage.getItem(CUMPLE_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CumpleSession;
    if (!parsed?.formData || Date.now() - parsed.savedAt > SESSION_TTL_MS) {
      sessionStorage.removeItem(CUMPLE_SESSION_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function saveCumpleSession(session: Omit<CumpleSession, "savedAt">) {
  try {
    sessionStorage.setItem(
      CUMPLE_SESSION_KEY,
      JSON.stringify({ ...session, savedAt: Date.now() } satisfies CumpleSession),
    );
  } catch {
    /* private mode / quota */
  }
}

export function clearCumpleSession() {
  try {
    sessionStorage.removeItem(CUMPLE_SESSION_KEY);
  } catch {
    /* ignore */
  }
}